import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  style: {"margin-bottom":"12px","font-size":"13px"}
}
const _hoisted_3 = { style: {"margin":"0 6px"} }
const _hoisted_4 = { class: "chk-week" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "cd-dow" }
const _hoisted_7 = { class: "cd-num" }
const _hoisted_8 = { class: "panel" }
const _hoisted_9 = { class: "bar" }
const _hoisted_10 = {
  key: 0,
  style: {"font-size":"12px","color":"#024E73","background":"#EAF1F5","border-radius":"8px","padding":"9px 12px","margin":"8px 0 14px"}
}
const _hoisted_11 = {
  key: 1,
  style: {"font-size":"12px","color":"#a8a4a0","margin":"8px 0 14px"}
}
const _hoisted_12 = {
  key: 2,
  style: {"font-size":"12px","color":"#a8a4a0","background":"#F6F5F3","border-radius":"8px","padding":"9px 12px","margin":"8px 0 14px"}
}
const _hoisted_13 = {
  key: 3,
  style: {"font-size":"12px","color":"#a8a4a0","background":"#F6F5F3","border-radius":"8px","padding":"9px 12px","margin":"8px 0 14px"}
}
const _hoisted_14 = {
  key: 4,
  class: "chk-weekly"
}
const _hoisted_15 = { class: "chk-weekly-head" }
const _hoisted_16 = {
  key: 0,
  class: "playbook-process checklist-text-block"
}
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { key: 0 }
const _hoisted_20 = {
  key: 0,
  class: "chk-missed"
}
const _hoisted_21 = {
  key: 5,
  class: "chk-oneoff"
}
const _hoisted_22 = { class: "chk-oneoff-head" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = {
  key: 0,
  class: "chk-missed"
}
const _hoisted_25 = {
  key: 1,
  class: "chk-added-by"
}
const _hoisted_26 = {
  key: 0,
  class: "chk-oneoff-add"
}
const _hoisted_27 = {
  key: 0,
  class: "playbook-process checklist-text-block",
  style: {"margin":"20px 0"}
}
const _hoisted_28 = {
  key: 1,
  class: "playbook-process checklist-text-block",
  style: {"margin":"20px 0"}
}
const _hoisted_29 = {
  key: 2,
  class: "playbook-process checklist-text-block",
  style: {"margin":"20px 0"}
}
const _hoisted_30 = ["innerHTML"]
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { key: 0 }
const _hoisted_33 = {
  key: 1,
  class: "panel"
}
const _hoisted_34 = { class: "page-filters" }
const _hoisted_35 = {
  key: 0,
  style: {"font-size":"12px","color":"#a8a4a0","padding":"6px 0 10px"}
}
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { class: "cl-date" }
const _hoisted_38 = { class: "cl-mon" }
const _hoisted_39 = { class: "cl-day" }
const _hoisted_40 = { class: "cl-yr" }
const _hoisted_41 = { style: {"flex":"1"} }
const _hoisted_42 = { class: "cl-nm" }
const _hoisted_43 = { class: "cl-sub" }
const _hoisted_44 = { class: "cl-right" }
const _hoisted_45 = {
  key: 2,
  class: "panel"
}
const _hoisted_46 = ["onClick"]
const _hoisted_47 = { class: "cl-date" }
const _hoisted_48 = { class: "cl-mon" }
const _hoisted_49 = { class: "cl-day" }
const _hoisted_50 = { class: "cl-yr" }
const _hoisted_51 = { style: {"flex":"1"} }
const _hoisted_52 = { class: "cl-nm" }
const _hoisted_53 = { class: "cl-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_checklist_log_detail = _resolveComponent("checklist-log-detail")!
  const _component_checklist_view_as_employee_picker = _resolveComponent("checklist-view-as-employee-picker")!

  return (_ctx.loaded)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.isAdmin)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_ctx.viewAsTarget)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _cache[8] || (_cache[8] = _createElementVNode("span", { style: {"color":"#a8a4a0"} }, "Viewing as", -1)),
                    _createElementVNode("b", _hoisted_3, _toDisplayString(_ctx.viewAsTarget.name), 1),
                    _createElementVNode("a", {
                      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.stopViewingAs()), ["prevent"])),
                      class: "primary",
                      style: {"text-decoration":"underline"}
                    }, "Stop viewing as")
                  ], 64))
                : (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.showViewAsPicker = true), ["prevent"])),
                    class: "primary",
                    style: {"text-decoration":"underline"}
                  }, "View as another user"))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weekDays, (day, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: i,
              onClick: ($event: any) => (_ctx.selectDay(day.dateString)),
              class: _normalizeClass(["chk-day", { on: day.dateString == _ctx.selectedDateString }])
            }, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(day.dow), 1),
              _createElementVNode("span", _hoisted_7, _toDisplayString(day.dateNum), 1),
              _createElementVNode("span", {
                class: _normalizeClass(["cd-dot", day.dotClass])
              }, null, 2)
            ], 10, _hoisted_5))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("h4", null, [
            _createTextVNode(_toDisplayString(_ctx.selectedDateLabel), 1),
            _createElementVNode("span", null, _toDisplayString(_ctx.doneCount) + "/" + _toDisplayString(_ctx.totalCount), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("span", {
              style: _normalizeStyle('width:' + _ctx.progressPct + '%')
            }, null, 4)
          ]),
          (_ctx.viewAsTarget)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, " Viewing " + _toDisplayString(_ctx.viewAsTarget.name) + "'s checklist — you can add one-off items on their behalf here. Everything else is read-only. ", 1))
            : (_ctx.isToday)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, " Filling out as " + _toDisplayString(_ctx.$store.state.user.firstName) + " " + _toDisplayString(_ctx.$store.state.user.lastName), 1))
              : (_ctx.isPast)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, " Read only — showing what was completed on " + _toDisplayString(_ctx.selectedDateLabel) + ". ", 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_13, " Upcoming — showing what's scheduled for " + _toDisplayString(_ctx.selectedDateLabel) + ". ", 1)),
          (_ctx.checklist.weeklyItems.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_svg_icon, { icon: "calendar" }),
                  _cache[9] || (_cache[9] = _createTextVNode("Weekly Items", -1))
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.checklist.weeklyItems, (item, i) => {
                  return (_openBlock(), _createElementBlock("div", { key: i }, [
                    (item.type == 'textblock')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _createElementVNode("div", {
                            innerHTML: item.text
                          }, null, 8, _hoisted_17)
                        ]))
                      : (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          onClick: ($event: any) => (_ctx.toggleItem(item)),
                          class: _normalizeClass(["chk-item", { on: item.checked, ro: _ctx.readOnlyMode }])
                        }, [
                          _createElementVNode("div", null, [
                            _createElementVNode("b", null, [
                              _createTextVNode(_toDisplayString(item.label), 1),
                              (item.description)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_19, ":"))
                                : _createCommentVNode("", true)
                            ]),
                            _cache[10] || (_cache[10] = _createTextVNode(" ", -1)),
                            _createElementVNode("span", null, _toDisplayString(item.description), 1),
                            (item.carriedFromLabel)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_20, "Missed " + _toDisplayString(item.carriedFromLabel), 1))
                              : _createCommentVNode("", true)
                          ])
                        ], 10, _hoisted_18))
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.checklist.oneOffItems.length || _ctx.isToday || _ctx.isFuture)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_component_svg_icon, {
                    icon: "plus",
                    style: {"width":"14px","height":"14px"}
                  }),
                  _cache[11] || (_cache[11] = _createTextVNode("One-Off Items", -1))
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.checklist.oneOffItems, (item, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: i,
                    class: "chk-oneoff-row"
                  }, [
                    _createElementVNode("div", {
                      onClick: ($event: any) => (_ctx.toggleItem(item)),
                      class: _normalizeClass(["chk-item", { on: item.checked, ro: _ctx.readOnlyMode }])
                    }, [
                      _createElementVNode("div", null, [
                        _createElementVNode("b", null, _toDisplayString(item.label), 1),
                        (item.carriedFromLabel)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_24, "Missed " + _toDisplayString(item.carriedFromLabel), 1))
                          : _createCommentVNode("", true),
                        (item.addedByName)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_25, "Added by " + _toDisplayString(item.addedByName), 1))
                          : _createCommentVNode("", true)
                      ])
                    ], 10, _hoisted_23),
                    (_ctx.isToday && !_ctx.viewAsTarget)
                      ? (_openBlock(), _createBlock(_component_svg_icon, {
                          key: 0,
                          onClick: ($event: any) => (_ctx.removeOneOffItem(item)),
                          icon: "x",
                          class: "chk-oneoff-remove"
                        }, null, 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128)),
                (_ctx.isToday || _ctx.isFuture)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.oneOffInput) = $event)),
                        onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.addOneOffItem()), ["enter"])),
                        placeholder: "Add a one-off item..."
                      }, null, 544), [
                        [_vModelText, _ctx.oneOffInput]
                      ]),
                      _createElementVNode("div", {
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.addOneOffItem())),
                        class: _normalizeClass(_ctx.oneOffInput.trim() ? 'btn' : 'btn disable-button'),
                        style: {"width":"auto","font-size":"14px"}
                      }, "Add", 2)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.checklist.items, (item, i) => {
            return (_openBlock(), _createElementBlock("div", { key: i }, [
              ((item.section && i == 0))
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _createElementVNode("b", null, _toDisplayString(item.section), 1)
                  ]))
                : ((i > 0 && item.section && _ctx.checklist.items[i-1].section != item.section))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                      _createElementVNode("b", null, _toDisplayString(item.section), 1)
                    ]))
                  : _createCommentVNode("", true),
              (item.type == 'textblock')
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _createElementVNode("div", {
                      innerHTML: item.text
                    }, null, 8, _hoisted_30)
                  ]))
                : (_openBlock(), _createElementBlock("div", {
                    key: 3,
                    onClick: ($event: any) => (_ctx.toggleItem(item)),
                    class: _normalizeClass(["chk-item", { on: item.checked, ro: _ctx.readOnlyMode }])
                  }, [
                    _createElementVNode("div", null, [
                      _createElementVNode("b", null, [
                        _createTextVNode(_toDisplayString(item.label), 1),
                        (item.description)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_32, ":"))
                          : _createCommentVNode("", true)
                      ]),
                      _cache[12] || (_cache[12] = _createTextVNode(" ", -1)),
                      _createElementVNode("span", null, _toDisplayString(item.description), 1)
                    ])
                  ], 10, _hoisted_31))
            ]))
          }), 128))
        ]),
        (_ctx.isAdmin && !_ctx.viewAsTarget && _ctx.adminHistoryEntries.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
              _cache[13] || (_cache[13] = _createElementVNode("h4", null, "All Users' History", -1)),
              _createElementVNode("div", _hoisted_34, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.adminSearchQ) = $event)),
                  placeholder: "Search by user name"
                }, null, 512), [
                  [_vModelText, _ctx.adminSearchQ]
                ])
              ]),
              (!_ctx.filteredAdminHistoryEntries.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, "No matching entries."))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredAdminHistoryEntries, (h, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  onClick: ($event: any) => (_ctx.showAdminEntry(h)),
                  class: "cl-card"
                }, [
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, _toDisplayString(h.mon), 1),
                    _createElementVNode("div", _hoisted_39, _toDisplayString(h.day), 1),
                    _createElementVNode("div", _hoisted_40, _toDisplayString(h.yr), 1)
                  ]),
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("div", _hoisted_42, _toDisplayString(h.userName), 1),
                    _createElementVNode("div", _hoisted_43, _toDisplayString(h.done) + "/" + _toDisplayString(h.total) + " items completed", 1)
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("span", {
                      class: _normalizeClass('pill ' + (h.total && h.done >= h.total ? 'p-done' : 'p-live'))
                    }, [
                      _createVNode(_component_svg_icon, {
                        icon: h.total && h.done >= h.total ? 'check2' : 'x'
                      }, null, 8, ["icon"]),
                      _createTextVNode(" " + _toDisplayString(h.total && h.done >= h.total ? 'Complete' : 'Incomplete'), 1)
                    ], 2)
                  ])
                ], 8, _hoisted_36))
              }), 128))
            ]))
          : (_ctx.historyEntries.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                _createElementVNode("h4", null, _toDisplayString(_ctx.viewAsTarget ? _ctx.viewAsTarget.name + "'s History" : 'My History'), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.historyEntries, (h, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: i,
                    onClick: ($event: any) => (_ctx.selectDay(h.dateString)),
                    class: "cl-card"
                  }, [
                    _createElementVNode("div", _hoisted_47, [
                      _createElementVNode("div", _hoisted_48, _toDisplayString(h.mon), 1),
                      _createElementVNode("div", _hoisted_49, _toDisplayString(h.day), 1),
                      _createElementVNode("div", _hoisted_50, _toDisplayString(h.yr), 1)
                    ]),
                    _createElementVNode("div", _hoisted_51, [
                      _createElementVNode("div", _hoisted_52, _toDisplayString(h.done) + "/" + _toDisplayString(h.total) + " items completed", 1)
                    ]),
                    _createElementVNode("div", _hoisted_53, [
                      _createElementVNode("span", {
                        class: _normalizeClass('pill ' + (h.total && h.done >= h.total ? 'p-done' : 'p-live'))
                      }, [
                        _createVNode(_component_svg_icon, {
                          icon: h.total && h.done >= h.total ? 'check2' : 'x'
                        }, null, 8, ["icon"]),
                        _createTextVNode(" " + _toDisplayString(h.total && h.done >= h.total ? 'Complete' : 'Incomplete'), 1)
                      ], 2)
                    ])
                  ], 8, _hoisted_46))
                }), 128))
              ]))
            : _createCommentVNode("", true),
        (_ctx.adminEntryToShow)
          ? (_openBlock(), _createBlock(_component_checklist_log_detail, {
              key: 3,
              entry: _ctx.adminEntryToShow,
              onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.adminEntryToShow = null))
            }, null, 8, ["entry"]))
          : _createCommentVNode("", true),
        (_ctx.showViewAsPicker)
          ? (_openBlock(), _createBlock(_component_checklist_view_as_employee_picker, {
              key: 4,
              onSelect: _ctx.startViewingAs,
              onClose: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showViewAsPicker = false))
            }, null, 8, ["onSelect"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}